<template>
  <div id="map_box">
    <div :id="chartId" class="main">map</div>
  </div>
</template>

<script>
import * as echarts from "echarts";
let geoJSON, chinaChart, option;
let minVal = 0,
  maxVal = 20;

export default {
  name: "WorkspaceJsonMap",
  props: {
    chartId: {
      type: String,
      default: "chartId",
    },
    mapProvince: {
      type: Array,
      default() {
        return [];
      },
    },
    showVisualMap: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      initCityIndex: 0,
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.initData("china", "c");
    },
    initData(map, type) {
      //引入地图数据并注册
      if (type == "c") {
        geoJSON = require("/public/china.json");
      } else {
        if (map == "china") {
          //针对南海诸岛没有对应地图--默认展示中国地图
          geoJSON = require("/public/china.json");
        } else {
        }
      }
      echarts.registerMap(map, { geoJSON });
      //设置对应省份地名数据
      /* let china_series_data = [
        { name: "新疆", value: 999 },
        { name: "重庆", value: 10 },
        { name: "四川", value: 200 },
        { name: "北京", value: 20 },
      ]; */
      /* 高亮数量最多的模块--
      后续渲染方法最后默认显示某个城市的tooltip
      -chinaChart.dispatchAction */
      let randomColor = [
        '#539FFC',
        '#6CC096',
        '#E399BB',
        // '#FFBF00',
        '#ccccff',
        '#9999ff',
        '#ff9999',
        '#669999'
      ]
      this.mapProvince.forEach((item, index) => {
        if (item.name == '吉林') {
          this.$set(item, "selected", true);
          this.initCityIndex = index;
        }
        item.itemStyle= {normal:{areaColor:randomColor[index % 7],label:{show:false}}}
        if(item.name == '重庆'){
        item.itemStyle= {normal:{areaColor:'#ccccff',label:{show:false}}}

        }
        // debugger;
      });
      let china_series_data = this.mapProvince;
      //设置高亮对应数据范围--最大最小值
      china_series_data.forEach((item) => {
        let val = item.value;
        maxVal = val > maxVal ? val : maxVal;
      });
      //初始化组件
      chinaChart = echarts.init(document.getElementById(this.chartId));
      this.renderChart(map, china_series_data, type);
    },
    renderChart(map, data, type) {
      option = {
        // backgroundColor: "#fff",

        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(255,255,255,0.7)",
          borderColor: "#ddd",
          borderWidth: "1",
          padding: 0,
          textStyle: {
            color: "#333",
          },
          formatter: function (b, c) {
            const { value, name } = b.data ? b.data : b;

            if (value > 0) {
              return `
              <div class="map-tooltip flex">
                <h5> ${name}：</h5>
                <p class="bluepoint">
                  ${value}家公司
                </p>
              </div>
              `;
            } else {
              return (
                '<div class="map-tooltip flex"><h5>' + name + "</h5></div>"
              );
            }
          },
        },
        toolbox: {
          show: false,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            dataView: {
              readOnly: false,
            },
            restore: {},
            saveAsImage: {},
          },
          iconStyle: {
            normal: {
              color: "#333",
            },
          },
        },
        animationDuration: 1000,
        animationEasing: "cubicOut",
        animationDurationUpdate: 1000,
        /* 设置地图大边框 */
        geo: {
          show: true,
          map: "china",
          label: {
            show: false,
          },
          roam: false,
          itemStyle: {
            normal: {
              // areaColor: "#000",
              borderWidth: 4, //设置外层边框
              borderColor: "#ccc",
              shadowColor: "#ccc", //外发光
              // borderColor: "#47A8EB",
              // shadowColor: "#47A8EB", //外发光
              shadowBlur: 20,
            },
            emphasis: {
              show: false,
              // areaColor: '#01215c'
            },
          },
        },
      };
      /* 设置地图具体小区域 */
      option.series = [
        {
          name: map,
          type: "map",
          mapType: map,
          roam: false,
          nameMap: {
            china: "中国",
          },
          label: {
            normal: {
              show: false,
              textStyle: {
                color: "#333",
                fontSize: 10,
              },
            },
            emphasis: {
              show: true,
              textStyle: {
                color: "#333",
                fontSize: 10,
              },
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#F4F8F9",
              borderColor: "#89C6F0",
              borderWidth: 1,
              // shadowColor: "#86C9FF", //外发光
              // shadowBlur: 5,
            },
            emphasis: {
              areaColor: "#FEE6A2",
            },
          },
          data: data,
        },
      ];
      let pieces = [];
      let piecesColors = [
        "#B2D7F5",
        "#92C8EF",
        "#81C0EC",
        "#61B0E7",
        "#51A8E4",
        "#41A0E1",
      ];
      let pingjun = (maxVal - minVal + 100) / 6;
      for (let i = 0; i < 6; i++) {
        pieces.push({
          gte: minVal + i * pingjun,
          lt: minVal + (i + 1) * pingjun,
          color: piecesColors[i],
        });
      }
      // option.visualMap = {
      //   type: "piecewise",
      //   show: this.showVisualMap,
      //   left: "1%",
      //   bottom: 40,
      //   min: minVal,
      //   max: maxVal,
      //   text: ["高", "低"],
      //   realtime: false,
      //   itemHeight: 10,
      //   orient: "horizontal",
      //   calculable: false,
      //   itemGap: 2,
      //   textGap: 10,
      //   pieces: pieces,
      //   /* [
      //     { gte: 0, lt: 50, color: "#B2D7F5" }, // 数值大于等于0，小于50
      //     { gte: 50, lt: 100, color: "#92C8EF" }, // 数值大于等于50，小于100
      //     { gte: 100, lt: 150, color: "#81C0EC" }, // 数值大于等于100，小于150
      //     { gte: 150, lt: 200, color: "#61B0E7" }, // 数值大于等于100，小于150
      //     { gte: 200, lt: 300, color: "#51A8E4" }, // 数值大于等于100，小于150
      //     { gte: 300, color: "#41A0E1" }, // 数值大于等于100，小于150
      //   ] */
      // };
      // chinaChart.setOption(option);
      //渲染地图
      if (type == "c") {
        chinaChart.setOption(option);
      } else {
        // option.series[0].center = [118.97, 35];
        option.series[0].zoom = 1;
      }
      // 默认显示某个城市的tooltip
      chinaChart.dispatchAction({
        type: "showTip",
        seriesIndex: 0, // 针对series下第几个数据
        dataIndex: this.initCityIndex, // 第几个数据
      });
      this.myEchartsClick();
    },
    myEchartsClick() {
      chinaChart.on("click", (params) => {
        this.$emit("cityClick", params);
      });
    },
  },
};
</script>

<style lang="less" scoped>
#map_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  /deep/.map-tooltip {
    height: 32px;
    line-height: 32px;
    display: flex;
    padding: 0 20px;
    align-items: center;
    font-size: 18px;
    > h5 {
    }
    .bluepoint {
      font-size: 16px;
    }
    &::before {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #86c9ff;
      position: relative;
      right: 10px;
    }
  }
}
.main {
  width: 100%;
  height: 100%;
}
</style>